import { render, staticRenderFns } from "./wuju-progress.vue?vue&type=template&id=1947383a&scoped=true&"
import script from "./wuju-progress.vue?vue&type=script&lang=js&"
export * from "./wuju-progress.vue?vue&type=script&lang=js&"
import style0 from "./wuju-progress.vue?vue&type=style&index=0&id=1947383a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1947383a",
  null
  
)

export default component.exports